export default __webpack_public_path__ + "7d7967806cf6e93db6f4d6a221f55cdd.webp";